// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Omit<T, K extends keyof any> = T extends any ? Pick<T, Exclude<keyof T, K>> : never;
export type Diff<T, U> = T extends U ? never : T;
export type NonNullable<T> = Diff<T, null | undefined>;
export type Non<T, U> = Diff<T, U>;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function nameof<T>(key: keyof T, instance?: T): keyof T {
  return key;
}
